import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import s from '../Cycles/Cycles.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Country, Theme } from 'enums';
import { withInjectedRootStore, RootStore } from 'providers';
import { CycleDetails } from 'types';

interface SaleBadgeProps {
  cycle: CycleDetails;
  rootStore: RootStore;
  isCycleSelected: boolean;
}

const SaleBadgeComp: React.FC<SaleBadgeProps> = ({
  cycle,
  rootStore,
  isCycleSelected,
}) => {
  const {
    fullTermActualPrice,
    fullTermDisplayPrice,
    firstPeriodPrice,
    cycleId,
  } = cycle;
  const { isResellerOffering } = rootStore.appStore;
  const { country } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();
  const isBrazil = country === Country.BR;
  const isWixStudio = theme === Theme.WixStudio;

  const getStateClasses = (): string => {
    if (isResellerOffering) {
      return `${s.resellerColors} ${isCycleSelected ? s.cycleSelected : ''}`;
    }

    if (!isCycleSelected) {
      return 'default-colors';
    }

    const baseClasses = 'bg-colors';
    const themeClass = isWixStudio ? 'studio-selected' : 'white-colors';
    const afterClass = 'bg-colors-after';

    if (!isBrazil) {
      const borderClasses = 'border-color border-color-after';
      return `${baseClasses} ${themeClass} ${afterClass} ${borderClasses}`;
    }

    return `${baseClasses} ${themeClass} ${afterClass}`;
  };

  const stateClasses = getStateClasses();

  const getBorderStyles = () => {
    if (isResellerOffering) {
      return [s.resellerBorderColor, s.resellerBorderColorAfter];
    }

    if (!isBrazil) {
      return [s.subscriptionPageSaleOptimisations8651];
    }

    return 'border-color border-color-after';
  };

  const borderStyles = getBorderStyles();
  return (
    <div
      data-hook={`sale-badge-${cycleId}`}
      className={classNames(s.saleBadge, stateClasses, borderStyles, theme, {
        [s.brazilBadge]: isBrazil,
      })}
    >
      <span className={classNames(s.saleBadgeContent, s.fontUpgrade, theme)}>
        <PremiumCurrencyFormatter
          currencySettingsOverride={{ fractionSize: 0 }}
          render={(formatCurrency) => (
            <Trans
              i18nKey='cycle_entry.cycle_discount'
              values={{
                discount: formatCurrency(
                  fullTermDisplayPrice -
                    (firstPeriodPrice || fullTermActualPrice),
                ),
              }}
            >
              Part 1<span className={s.salePriceText}>Part 2</span>
            </Trans>
          )}
        />
      </span>
    </div>
  );
};

export const SaleBadge = withInjectedRootStore(SaleBadgeComp);
